import axios from 'axios';

// Set config defaults when creating the instance
export const instance = axios.create({
    //Set the base url for back end
    baseURL: 'https://philhist-papyri-01.philhist.unibas.ch/api'
    // baseURL: 'http://127.0.0.1:5000'
});
